import { UPDATES_ALL_ACTION_TYPE } from "../actions-type";

const initialState = {
  allUpdates: [],
  loading: false,
};

export const updatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATES_ALL_ACTION_TYPE.GET_ALL_UPDATES:
      return {
        ...state,
        allUpdates: action.payload,
      };
    case UPDATES_ALL_ACTION_TYPE.CHANGE_UPDATES_STATUS:
      return {
        allUpdates: state.allUpdates.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
      };
    case UPDATES_ALL_ACTION_TYPE.LOADING_UPDATES:
      return {
        ...state,
        loading: action.payload,
      };
    case UPDATES_ALL_ACTION_TYPE.RESET_UPDATES:
      return initialState;

    default:
      return state;
  }
};
